import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { AccountLayout } from '@/components/ui/AccountLayout';
import { PaywallHeader } from '@/components/paywall/PaywallHeader';
import chevronRightUrl from '@/assets/icons/chevron-right.svg?url';
import { ROUTES } from '@/constants/routes';
import { AppStoreDownloadBadge } from '@/components/ui/AppStoreDownloadBadge';

const Header = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Content = styled.div`
  margin-top: 16px;
`;

const PolicyMenu = styled.div`
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #0000001a;
`;

const ContactMenu = styled.div`
  display: grid;
  gap: 12px;
`;

const Item = styled(Link)`
  display: flex;
  align-items: center;
  padding: 7px 16px;
  text-decoration: none;
  color: #212121;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.41px;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`;

const ContactItem = styled(Link)`
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 10px 0px #0000001a;
  padding: 16px 12px;
  border-radius: 12px;
  background: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: -0.32px;
  text-decoration: none;
  color: #212121;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`;

const ItemIcon = styled.div`
  font-size: 20px;
  margin-right: 12px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemText = styled.span`
  flex: 1;
  position: relative;
`;

const ItemTextWithDivider = styled(ItemText)`
  ${PolicyMenu} ${Item}:not(:last-child) &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #e5e7eb;
    position: absolute;
    bottom: -11px;
    left: 0;
  }
`;

const ItemArrow = styled.img`
  margin-left: 16px;
  flex-shrink: 0;
  width: 8px;
  height: 14px;
`;

const Section = styled.h2`
  margin: 36px 0 8px;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.32px;
  font-weight: 400;
`;

const policyItems = [
  {
    icon: '📄',
    text: 'Terms of Service',
    to: ROUTES.POLICY.TERMS,
  },
  {
    icon: '👑',
    text: 'Subscription Information & Refund Policy',
    to: ROUTES.POLICY.SUBSCRIPTION,
  },
  {
    icon: '🔒',
    text: 'Privacy Policy',
    to: ROUTES.POLICY.PRIVACY,
  },
];

const contactItems = [
  {
    text: 'My feedback about the app',
    to: ROUTES.POLICY.FEEDBACK,
  },
  {
    text: 'Questions about the app',
    to: ROUTES.POLICY.FEEDBACK,
  },
  {
    text: 'Request to unblock a website / app',
    to: ROUTES.POLICY.FEEDBACK,
  },
];

export function PolicyIndex() {
  return (
    <AccountLayout showLogo showGear showHome>
      <Header>
        <PaywallHeader>Policy Menu</PaywallHeader>
      </Header>
      <Content>
        <PolicyMenu>
          {policyItems.map((item) => (
            <Item key={item.to} to={item.to}>
              <ItemIcon>{item.icon}</ItemIcon>
              <ItemTextWithDivider>{item.text}</ItemTextWithDivider>
              <ItemArrow src={chevronRightUrl} alt="" />
            </Item>
          ))}
        </PolicyMenu>

        <AppStoreDownloadBadge />

        <Section>Contact Us</Section>
        <ContactMenu>
          {contactItems.map((item, idx) => (
            <ContactItem key={idx} to={item.to}>
              <ItemText>{item.text}</ItemText>
              <ItemArrow src={chevronRightUrl} alt="" />
            </ContactItem>
          ))}
        </ContactMenu>
      </Content>
    </AccountLayout>
  );
}
